<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="mode === 'list'">
      <v-toolbar :dense="true" >
        <v-toolbar-title> <v-icon>mdi-history</v-icon> Status </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-data-table :headers="statusColumns" :items="statuses" class="elevation-1" hide-default-footer>
        <template v-slot:item="row"
          ><tr>
            <td>{{ formatDisplayDate(row.item.statDate) }}</td>
            <td>{{ formatDisplayDateTime(row.item.entDate) }}</td>
            <td>{{ row.item.clmStatDesc }}{{ row.item.status === 'P' ? ' (P)' : '' }}</td>
            <td>{{ row.item.cseStatDesc }}</td>
            <td>{{ row.item.usrName }}</td>
          </tr></template
        >
      </v-data-table>
      <v-card-actions>
        <v-btn color="primary" :disabled="isStatusP" @click.native="openForm">
          <span>Claim Status</span>
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="mode === 'new'">
      <v-toolbar :dense="true" >
        <v-toolbar-title> <v-icon>mdi-history</v-icon> New Claim Status </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <cal-picker
              v-model="statusForm.statDate"
              :label="labels.statDate"
              :error-messages="errors.collect('statusForm.statDate')"
              :data-vv-as="labels.statDate"
              data-vv-name="statusForm.statDate"
              v-validate="doValidateDate"
              :min="parseDateISO(tDateRange.effDate)"
              :max="parseDateISO(tDateRange.expDate)"
            >
            </cal-picker>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              v-model="statusForm.clmStat"
              :items="claimStatList"
              :label="labels.clmStat"
              item-text="label"
              item-value="value"
              @change="doCauseList(statusForm.clmStat)"
              :data-vv-as="labels.clmStat"
              :error-messages="errors.collect('statusForm.clmStat')"
              data-vv-name="statusForm.clmStat"
              v-validate="'required'"
            />
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              v-model="statusForm.cseStat"
              :items="causeStatList"
              :label="labels.cseStat"
              item-text="label"
              item-value="value"
              :data-vv-as="labels.cseStat"
              :error-messages="errors.collect('statusForm.cseStat')"
              data-vv-name="statusForm.cseStat"
              v-validate="'required'"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="doSave(true)" :loading="loading">Save</v-btn>
        <v-btn color="red darken-1" text @click.native="mode = 'list'">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="mode === 'zerolise'">
      <v-toolbar :dense="true" >
        <v-toolbar-title> <v-icon>mdi-history</v-icon> Close Claim - Outstanding Reserve </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12> One or more O/S Reserves is not zero. Zerorise all reserves and close claim? (70076)" </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="doSave(false)" :loading="loading">Yes</v-btn>
        <v-btn color="red" @click.native="doCancelZerolise">No</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-auth v-model="promptAuthApproveTxt" @ok="transferToQuery" yes-label="Exit" :info="true">{{ authApproveTxt }}</confirm-auth>
  </v-container>
</template>

<script>
import { formatDisplayDate, formatDisplayDateTime4, removeTime } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { parseISO, isAfter, isBefore, isEqual } from 'date-fns'
import clone from 'clone'
import { expandURI } from '@/utils/ajax'
import ConfirmAuth from '@/components/core/claimManagement/ConfirmAuth'

export default {
  props: {
    clmStat: String
  },
  mounted() {
    this.getTranDateRange()
    this.getClaimStats()
  },
  data() {
    return {
      loading: false,
      mode: 'list',
      statusColumns: [
        { text: 'Date of Status', align: 'left', value: 'statDate' },
        { text: 'Entry Date', align: 'left', value: 'entDate' },
        { text: 'Status', align: 'left', value: 'clmStat' },
        { text: 'Cause of Status', align: 'left', value: 'cseStat' },
        { text: 'User ID', align: 'left', value: 'usrId' }
      ],
      labels: {
        statDate: 'Date of Status',
        clmStat: 'Claims Status',
        cseStat: 'Cause of Status'
      },
      statusForm: {
        clmNo: undefined,
        statDate: undefined,
        clmStat: undefined,
        cseStat: undefined,
        busCls: undefined
      },
      claimStatList: [],
      causeStatList: [],
      defCauseStatList: [],
      trandaterange: {},
      authApproveTxt: 'User Not Authorised to Approve Transaction',
      promptAuthApproveTxt: false
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    menu() {
      return this.$store.state.claims.claimDetail.menu
    },
    tranDate() {
      return this.$store.state.claims.claimDetail.tranDate || new Date()
    },
    statuses() {
      return this.commonInfo.claimStatuses
    },
    isStatusP() {
      return Array.isArray(this.statuses) && this.statuses.some(item => item.status === 'P')
    },
    tDateRange() {
      return this.trandaterange
    },
    doValidateDate() {
      const today = new Date()
      return 'required|statDate:' + this.tDateRange.effDate + ',' + this.tDateRange.expDate + '|valDate:' + today
    }
  },
  created() {
    this.$validator.extend('statDate', {
      getMessage(field, args) {
        return 'Date not within permitted Date Range.(17)'
      },
      validate(value, args) {
        let effDate = args[0]
        let expDate = args[1]
        if (value) {
          return (isAfter(removeTime(value), removeTime(effDate)) || isEqual(removeTime(value), removeTime(effDate))) &&
          (isBefore(removeTime(value), removeTime(expDate)) || isEqual(removeTime(value), removeTime(expDate)))
        } else return true
      }
    })
    this.$validator.extend('valDate', {
      getMessage(field, args) {
        return 'This date cannot be greater today'
      },
      validate(value, args) {
        let today = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(today))
        } else return true
      }
    })
  },
  methods: {
    openForm() {
      this.mode = 'new'
      this.statusForm.statDate = this.tranDate
      this.statusForm.clmStat = undefined
      this.statusForm.cseStat = undefined
      if (this.clmStat === 'R') {
        this.statusForm.clmStat = this.clmStat
        this.doCauseList(this.statusForm.clmStat)
      }
    },
    doClose() {
      this.$emit('close')
    },
    doCancelZerolise() {
      this.$toast.error('This Claim is not closed. (70114)')
      this.openForm()
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    },
    formatDisplayDateTime(value) {
      if (value) {
        return formatDisplayDateTime4(value)
      } else {
        return ''
      }
    },
    async getTranDateRange() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonData('trandaterange', '300')
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    async getClaimStats() {
      const apiURI = this.$store.state.claims.claimRegister.menu.getClaimStats
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.claimStatList = []
          this.defCauseStatList = []
          if (data) {
            data.map((item) => {
              if (this.clmStat === 'R') {
                if (item.clmStat !== 'O') {
                  const claimStatReopen = {
                    value: item.clmStat,
                    label: item.clmStatDesc
                  }
                  this.claimStatList.push(claimStatReopen)
                }
              } else {
                const claimStat = {
                  value: item.clmStat,
                  label: item.clmStatDesc
                }
                this.claimStatList.push(claimStat)
              }
              item.clmStatCauseList.map((element) => {
                const causeStat = {
                  value: element.value,
                  secondaryValue: element.secondaryValue,
                  label: element.label
                }
                this.defCauseStatList.push(causeStat)
              })
              if (this.statusForm.clmStat !== undefined) {
                this.doCauseList(this.statusForm.clmStat)
              }
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCauseList(value) {
      this.causeStatList = []
      this.defCauseStatList.map((item) => {
        if (item.secondaryValue === value) {
          const causeStat = {
            label: item.label,
            value: item.value
          }
          this.causeStatList.push(causeStat)
        }
      })
    },
    async doSave(checkZerolise) {
      if (this.statusForm.clmStat === 'C') {
        await this.getLatestPlanPaytLoc()
        if (this.commonInfo.planPaytLoc > 0) {
          this.$toast.error('Some payments are not released yet. (70075)')
          return
        }
        if (checkZerolise) {
          if (this.commonInfo.hasOSRes) {
            this.mode = 'zerolise'
            return
          }
        }
      }
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doSaveClaimStatus().then((saveResult) => {
            if (saveResult !== '') {
              this.authApproveTxt = saveResult
              this.promptAuthApproveTxt = true
              this.showClaimStatusDialog = false
            } else {
              if (this.mode === 'zerolise') {
                this.transferToQuery()
              }
              this.mode = 'list'
              location.reload()
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async transferToQuery() {
      // const dispatchObj = {
      //   clmNo: this.commonInfo.clmNo,
      //   remove: false,
      //   query: true
      // }
      // await this.$store.dispatch('loadClaim', dispatchObj)
      // await this.$store.dispatch('claimEntryInit')
      // await this.$store.dispatch('claimsRegisterInit')
      // // Check status and redirect to the correct page
      this.$root.$emit('leaveClaim')
      this.$router.push({ name: 'mngClaim' })
    },
    async doSaveClaimStatus() {
      try {
        this.loading = true
        this.statusForm.clmNo = this.commonInfo.clmNo
        this.statusForm.busCls = this.commonInfo.busCls
        let messageFilters = clone(this.statusForm)
        if (messageFilters.statDate !== null && messageFilters.statDate !== '') {
          messageFilters.statDate = removeTime(messageFilters.statDate)
        }
        const message = await this.$store.dispatch('saveClaimStatus', messageFilters)
        this.loading = false
        return message
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.processingFlag = false
          this.loading = false
          this.notify(data)
        }
        return false
      }
    },
    async getLatestPlanPaytLoc() {
      const expand = {
        clmNo: this.commonInfo.clmNo
      }
      const apiUrl = this.menu.getLatestPlanPaytLoc
      if (apiUrl) {
        try {
          const response = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = response.data
          this.commonInfo.planPaytLoc = data.result
        } catch {}
      }
    }
  },
  components: {
    ConfirmAuth
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
